import { Injectable } from '@angular/core';
import { Dashboard } from '@shared/models';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class DashboardService {
  private activeDashboard = new ReplaySubject<Dashboard>(1);
  public activeDashboard$ = this.activeDashboard.asObservable();

  private theme = new ReplaySubject<string>(1);
  public theme$ = this.theme.asObservable();

  selectDashboard(dashboard: Dashboard) {
    this.activeDashboard.next(dashboard);
  }

  public changeTheme(theme: string): void {
    this.theme.next(theme);
  }
}
